import { CompanySetting } from "domain-entities";
import { DEFAULT_WORKING_HOURS_TIME_RANGE } from "../constants/DEFAULT_WORKING_HOURS_TIME_RANGE";
import { TimeRange } from "../types/TimeRange";

export function getCompanyWorkingHours(
	companySetting?: CompanySetting
): TimeRange {
	if (companySetting?.workingHours) {
		return companySetting.workingHours;
	} else {
		return DEFAULT_WORKING_HOURS_TIME_RANGE;
	}
}
